import type { IncidentLog } from "@/models"
import NarrativeList from "@/pages/shared/incident-form/sections/narrative/NarrativeList"
import { computed } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	incident: IncidentLog
}

const Narrative: ReactiveComponent<Props> = (props) => {
	const narrative = computed(() =>
		props.incident.incidentNarrative.toSorted((n1, n2) =>
			n1.creationMetadata.timeStamp.compareTo(n2.creationMetadata.timeStamp)
		)
	)

	return () =>
		narrative.value.length === 0 ? <p>No narrative has been added.</p> : <NarrativeList entries={narrative.value} />
}

export default defineComponent(Narrative, inferProps<Props>())
